/* istanbul ignore file */

import {Log} from '../models/Log.interface';

export abstract class LoggingProvider {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static log(log: Log) {}
}
